import { render, staticRenderFns } from "./Order.vue?vue&type=template&id=a2f123a8&scoped=true&"
import script from "./Order.vue?vue&type=script&lang=ts&"
export * from "./Order.vue?vue&type=script&lang=ts&"
import style0 from "./Order.vue?vue&type=style&index=0&id=a2f123a8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2f123a8",
  null
  
)

export default component.exports